import { useCallback } from 'react';
import { localGetData, localStoreData } from '../utils/utils';

const useUpdateOpenArray = (user) => {
  const handleUpdate = useCallback((id, action, type) => {

    const allowedTypes = ["tickets", "incidents", "people", "vehicles"];

    if (!allowedTypes.includes(type)) {
      alert("Invalid type: ", type);
      return;
    }

    if (!user || !id) return;

    let openItems = localGetData(`${user.id}-open-${type}`) || [];
    switch (action) {
      case "open":
        if (!openItems.includes(id)) {
          openItems.push(id);
          localStoreData(openItems, `${user.id}-open-${type}`);
        }
        break;
      case "close": {
        let closeIndex = openItems.findIndex(i => i === id)
        if (closeIndex > -1) {
          openItems.splice(closeIndex, 1)
          localStoreData(openItems, `${user?.id}-open-${type}`)
        }
        break;
      }
      default:
        alert("Invalid action: ", action);
        break;
    }
  }, [user]);

  return handleUpdate;
};

export default useUpdateOpenArray;